import "../App.css";

function About() {
  return (
    <div>
      <div className="centerP">
        <div className="aboutPs">
          <p className="aboutCs">
            We at Yummy Tacos specialize in providing delicious and authentic
            Mexican tacos for various events and occasions. We bring the vivid
            flavors and festive spirit of Mexico right to your doorstep.
          </p>
        </div>
        <h1 className="aboutH1"> Our Packages </h1>
      </div>
      <div className="container">
        <div>
          <h1>50 People $850</h1>
          <p>Mexican Flavored water -Horchata & Mango</p>
          <p>Chicken , Carne Asada , Al Pastor, Chorizo </p>
          <p>Corn Tortillas</p>
          <p>Limes/Cilantro/Onions/Salsa Verde & Roja</p>
        </div>
        <div>
          <h1>100 People $1700</h1>
          <p>Mexican Flavored water -Horchata & Mango</p>
          <p> Chicken , Carne Asada , Al Pastor, Chorizo </p>
          <p>Corn Tortillas</p>
          <p>Limes/Cilantro/Onions/Salsa Verde & Roja </p>
        </div>
      </div>
    </div>
  );
}

export default About;
